var root = (window.env && window.env.KWANZA_URL) || process.env.KWANZA_URL
var socketRoot = (window.env && window.env.KWANZA_STREAMURL) || process.env.KWANZA_STREAMURL
var disableBlockly =
  (window.env && window.env.CUESTA_DISABLE_BLOCKLY) || process.env.CUESTA_DISABLE_BLOCKLY
var allowNonMaintainersToEditFlows =
  (window.env && window.env.CUESTA_ALLOW_NON_MAINTAINERS_TO_EDIT_FLOWS) ||
  process.env.CUESTA_ALLOW_NON_MAINTAINERS_TO_EDIT_FLOWS
var disallowKeyboardTriggerDebounce =
  (window.env && window.env.CUESTA_DISALLOW_KEYBOARD_TRIGGER_DEBOUNCE) ||
  process.env.CUESTA_DISALLOW_KEYBOARD_TRIGGER_DEBOUNCE
var disableDebugger =
  (window.env && window.env.CUESTA_DISABLE_DEBUGGER) || process.env.CUESTA_DISABLE_DEBUGGER
var allowAppLaunchViaFlow =
  (window.env && window.env.CUESTA_ALLOW_APP_LAUNCH_VIA_FLOW) ||
  process.env.CUESTA_APP_ALLOW_LAUNCH_VIA_FLOW

let manateeHost = () => {
  return (
    (document.body.attributes['manatee_host'] && document.body.attributes['manatee_host'].value) ||
    (window.env && window.env.MANATEE_HOST) ||
    process.env.MANATEE_HOST ||
    'localhost'
  )
}

var websocketPort = () => {
  return (
    (document.body.attributes['manatee_monitorport'] &&
      parseInt(document.body.attributes['manatee_monitorport'].value, 10)) ||
    0
  )
}

var websocketPortSecure = () => {
  return (
    (document.body.attributes['manatee_monitorport_secure'] &&
      parseInt(document.body.attributes['manatee_monitorport_secure'].value, 10)) ||
    0
  )
}

function buildSocketUrl(endpointName, host, port, securePort) {
  const finalPort = port || websocketPort() || defaultWebsocketPort()
  const finalSecurePort = securePort || websocketPortSecure() || defaultWebsocketPortSecure()
  const useSecure = securePort || (!port && finalSecurePort) // If user specified 'secure' or user specified nothing and a secure port is known
  const finalHost = host || manateeHost()
  const secureHost =
    finalHost === 'localhost' || finalHost === '127.0.0.1' ? 'localhost.sirenia.io' : finalHost
  return useSecure
    ? `wss://${secureHost}:${finalSecurePort}/${endpointName}`
    : `ws://${finalHost}:${finalPort}/${endpointName}`
}

const defaultWebsocketPort = () =>
  (window.env && parseInt(window.env.MANATEE_MONITORPORT, 10)) ||
  (process.env && parseInt(process.env.MANATEE_MONITORPORT, 10)) ||
  50580

const defaultWebsocketPortSecure = () =>
  (window.env && parseInt(window.env.MANATEE_MONITORPORT_SECURE, 10)) ||
  (process.env && parseInt(process.env.MANATEE_MONITORPORT_SECURE, 10)) ||
  0

var esteroUrl = (window.env && window.env.ESTERO_URL) || process.env.ESTERO_URL
var esteroStreamUrl = (window.env && window.env.ESTERO_STREAMURL) || process.env.ESTERO_STREAMURL

export {
  root,
  socketRoot,
  websocketPort,
  websocketPortSecure,
  defaultWebsocketPort,
  defaultWebsocketPortSecure,
  manateeHost,
  disableBlockly,
  allowNonMaintainersToEditFlows,
  disallowKeyboardTriggerDebounce,
  disableDebugger,
  buildSocketUrl,
  esteroUrl,
  esteroStreamUrl,
  allowAppLaunchViaFlow
}

export default {
  root,
  socketRoot,
  manateeHost,
  websocketPort,
  websocketPortSecure,
  defaultWebsocketPort,
  defaultWebsocketPortSecure,
  disableBlockly,
  allowNonMaintainersToEditFlows,
  disallowKeyboardTriggerDebounce,
  disableDebugger,
  buildSocketUrl,
  esteroUrl,
  esteroStreamUrl,
  allowAppLaunchViaFlow
}
